(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onOfferClick(event) {
      event?.preventDefault();
      const selector = document.querySelector(`#ProductSelector-${this.dataset.sectionId} product-selector`);
      const cartDrawer = document.querySelector('cart-drawer');
      if (!selector || !cartDrawer) return;

      if (selector.needsSize()) {
        document.querySelector('.product__swatch--button')?.closest('fieldset')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const variant = selector.getVariantData();
      if (!variant?.available) {
        this.handleErrorMessage(window.variantStrings.soldOut);
        return;
      }

      this.handleErrorMessage();
      this.offerButton?.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData();
      const piece = Date.now();
      formData.append('items[0][id]', variant.id);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][_piece]', String(piece));
      formData.append('items[1][id]', variant.id);
      formData.append('items[1][quantity]', '1');
      formData.append('items[1][properties][_piece]', String(piece + 1));
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.offerButton?.classList.remove('disabled');
        });
    }

    onSubmitHandler(event) {
      if (this.submitButton?.classList.contains('product-selector__submit--choose-size')) {
        event.preventDefault();
        document.querySelector('.product__swatch--button')?.closest('fieldset')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }


    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();

if (window.__bodysuitOfferClick) {
  document.removeEventListener('click', window.__bodysuitOfferClick, true);
}

window.__bodysuitOfferClick = event => {
  const button = event.target.closest('.product-selector__offer');
  if (!button || button.classList.contains('disabled')) return;

  event.preventDefault();
  event.stopPropagation();
  const form = button.closest('product-form');
  const selector = document.querySelector(`#ProductSelector-${form?.dataset.sectionId} product-selector`) || document.querySelector('product-selector');
  const cartDrawer = document.querySelector('cart-drawer');
  if (!selector || !cartDrawer) return;

  if (selector.needsSize()) {
    document.querySelector('.product__swatch--button')?.closest('fieldset')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  const variant = selector.getVariantData();
  if (!variant?.available) {
    form?.handleErrorMessage?.(window.variantStrings.soldOut);
    return;
  }

  form?.handleErrorMessage?.();
  button.classList.add('disabled');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  const formData = new FormData();
  const piece = Date.now();
  formData.append('items[0][id]', variant.id);
  formData.append('items[0][quantity]', '1');
  formData.append('items[0][properties][_piece]', String(piece));
  formData.append('items[1][id]', variant.id);
  formData.append('items[1][quantity]', '1');
  formData.append('items[1][properties][_piece]', String(piece + 1));
  formData.append('sections', cartDrawer.getSectionsToRender().map(section => section.section));
  formData.append('sections_url', window.location.pathname);
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        form?.handleErrorMessage?.(response.description);
        return;
      }
      cartDrawer.open();
      cartDrawer.renderContents(response);
    })
    .catch(error => {
      console.error(error);
    })
    .finally(() => {
      button.classList.remove('disabled');
    });
};

document.addEventListener('click', window.__bodysuitOfferClick, true);
